/**
 *-------------------------------------------
 * apis in client management page
 *-------------------------------------------
 */

import { postData } from '../../request'

export function getAnalysisList(payload, cfg = {}) {
    return postData('/api/analysis/getAnalysisList', payload, cfg)
}

export function uploadAnalysis(payload, cfg = {}) {
    return postData('/api/analysis/uploadAnalysis', payload, cfg)
}

export function downloadAnalysis(payload, cfg = {}) {
    return postData('/api/analysis/downloadAnalysis', payload, cfg)
}
